const styles = {
  navButtonSx: { my: 2, color: "white", display: "block", width: "100px" },

  desktopBarSx: {
    display: { xs: "none", md: "flex" },
    alignItems: "center",
    flex: 1,
    justifyContent: "space-between",
  },

  desktopNavGroupSx: { display: "flex" },

  getLogoBoxSx: (isActive, pathname) => ({
    display: "flex",
    opacity: (isActive && pathname === "/") ? 0 : 1,
    transform: (isActive && pathname === "/") ? "scale(0.72)" : "scale(1)",
    pointerEvents: (isActive && pathname === "/") ? "none" : "auto",
    transition: "opacity 0.5s cubic-bezier(0.22, 1, 0.36, 1), transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)",
  }),

  mobileBarSx: {
    display: { xs: "flex", md: "none" },
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },

  drawerPaperSx: {
    width: "75vw",
    maxWidth: 320,
    backgroundColor: "#111",
    display: "flex",
    flexDirection: "column",
    pt: 2,
    px: 3,
  },

  drawerHeaderSx: { display: "flex", justifyContent: "flex-end", mb: 4 },

  drawerNavSx: { display: "flex", flexDirection: "column", gap: 1 },

  drawerButtonSx: {
    color: "white",
    justifyContent: "flex-start",
    fontSize: "18px",
    fontWeight: 500,
    py: 1.5,
    px: 0,
    borderBottom: "1px solid #2a2a2a",
    borderRadius: 0,
    letterSpacing: "0.05em",
    "&:hover": { backgroundColor: "transparent", color: "#aaa" },
  },
};

export default styles;
